import PropTypes from 'prop-types';
import ImageProp from '../../../commonComponents/propTypes/imageProp';

const propType = {
  trophies: PropTypes.shape({
    scores: PropTypes.number,
    points: PropTypes.number,
    winner: PropTypes.bool,
  }),
  coins: PropTypes.shape({}),
  coupon: PropTypes.shape({
    name: PropTypes.string,
    info: PropTypes.string,
    image: PropTypes.shape(ImageProp.propType),
  }),
  voucher: PropTypes.shape({
    name: PropTypes.string,
    info: PropTypes.string,
    logo: PropTypes.shape(ImageProp.propType),
  }),
};

export default { propType };
